import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import { useSetting } from '@tencent/setting-vue-webpack-plugin';
import login from '@tencent/vft-common/login';
export var baseSetting = useSetting('页面基础', {
  默认分享: {
    type: 'object',
    properties: {
      分享标题: {
        type: 'string',
        default: '腾讯视频VIP'
      },
      分享描述: {
        type: 'string',
        default: '腾讯视频VIP'
      },
      分享朋友圈标题: {
        type: 'string',
        default: '腾讯视频VIP'
      },
      分享图: {
        type: 'image',
        default: 'https://puep.qpic.cn/vupload/0/20171219_1513666453486.png/0'
      },
      分享链接: {
        type: 'url',
        default: 'https://film.qq.com/h5/vip-center/'
      }
    }
  }
});
export var devSetting = useSetting('开发者工具', {
  调试模式: true,
  强制进入调试模式vuid: {
    type: 'array',
    items: {
      type: 'string',
      default: '135051317'
    }
  },
  开启日志: true,
  按模块开启日志: {
    type: 'array',
    items: {
      type: 'string',
      default: 'log'
    }
  },
  使用mirrorEye: false,
  sentry: {
    type: 'object',
    properties: {
      上报Url: 'https://4d437273cb9841d5983d39f88995353d@report.url.cn/sentry/1471',
      采样率: 1,
      忽略错误: {
        type: 'array',
        items: {
          type: 'string',
          default: 'WeixinJSBridge is not defined'
        }
      }
    }
  }
});
export var vuid = login.getVuid();
export var debuggerMode = devSetting.调试模式 || devSetting.强制进入调试模式vuid.includes(vuid);